import React, {FC, ReactNode} from "react"
import styled from "styled-components"
import {IconTypes} from "@irati/ui/src/Icon"

import IconText from "../IconText"

interface Props {
  id?: string,
  icon?: IconTypes,
  small?: boolean,
  hasError?: boolean,
  children: ReactNode
}

export default styled<FC<Props>>(({children, icon, hasError, ...rest}) => (
  <IconText icon={icon || IconTypes.info} {...rest}>
    {children}
  </IconText>
))`
  color: ${({theme, hasError}) => (hasError ? theme.colors.tertiary.r_400 : theme.colors.utility.ink)};
`
